import { render, staticRenderFns } from "./Richieste.vue?vue&type=template&id=c3525d00&scoped=true&"
import script from "./Richieste.vue?vue&type=script&lang=js&"
export * from "./Richieste.vue?vue&type=script&lang=js&"
import style0 from "./Richieste.vue?vue&type=style&index=0&id=c3525d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3525d00",
  null
  
)

export default component.exports